import React from 'react';
import { Redirect, Route, Switch } from "react-router-dom"
import ProjectViewer from '../../components/projectViewer/ProjectViewer';
import Monitor from '../progress/monitor/Monitor';
import ProgressCleaner from '../progress/real-time/ProgressCleaner';
import RealTime from '../progress/real-time/RealTime';
import { RtProgressNav } from './RtProgressNav';

export const RtProgress = (props: {
    username: string;
}) => {
    return <>
        <div className="flex-grow-1 container-fluid row justify-content-center">
            <div className="col-md-11">
                <ProjectViewer/>
                <Switch>
                    {/* 显示主界面  导航 */}
                    <Route path={`/${props.username}/rtprogress/seismic/nav`}>
                        <RtProgressNav username={props.username} />
                    </Route>
                    {/* 每个模块得主界面内容页 */}
                    <Route path={`/${props.username}/rtprogress/:spec/:tech`}>
                        <ProgressCleaner index={1} />
                        {/* WebSocket */}
                        <Monitor />
                        {/* 内容页 */}
                        <RealTime />
                    </Route>
                    {/* 进入模块后退出时主界面 */}
                    <Redirect to={`/${props.username}/rtprogress/seismic/nav`} />
                </Switch>
            </div>
        </div>
    </>
       
}